export default __webpack_public_path__ + "static/media/2139.b0f7fcf3.png";